import { defineStore } from 'pinia'
import { useEzioAPI } from '@ezio/services'

export const useSearchStore = defineStore('search', () => {
    const { api } = useEzioAPI()

    const search = async (query: string, types: string[]) => {
        // const response = await api.custom({
        //     method: 'get',
        //     baseURL: import.meta.env.VITE_EZIO_API_URL + 'v1/',
        //     url: 'search',
        //     params: {
        //         q: query,
        //         types: types.join(',')
        //     }
        // })
        const response = await api.get('search', {
            q: query,
            types: types.join(',')
        })
        console.log(response)
        return response.data
    }

    return { search }
})
